// @see: https://www.npmjs.com/package/@intercom/messenger-js-sdk
// @see: https://developers.intercom.com/installing-intercom/web/attributes-objects
import { Intercom } from '@intercom/messenger-js-sdk';
import { hide } from '@intercom/messenger-js-sdk';
import { show } from '@intercom/messenger-js-sdk';
import { showArticle } from '@intercom/messenger-js-sdk';
import { showSpace } from '@intercom/messenger-js-sdk';
import { update } from '@intercom/messenger-js-sdk';

export const intercom = {
  initialized: false,
  sdk: {
    hide,
    initialization: Intercom,
    show,
    showArticle,
    showSpace,
    update,
  },
  // https://developers.intercom.com/installing-intercom/web/attributes-objects#data-attributes
  settings: {
    app_id: null,
    user_id: null,
    name: null,
    email: null,
    created_at: null,
  },

  initialize: function(settings) {
    if (!this.initialized && settings) {
      if (!settings.app_id) {
        console.error('Intercom app_id not found');
        return;
      }
      this.settings = settings;

      window._intercom = this;

      // Remove undefined values
      Object.keys(this.settings).forEach(key => {
        if ((this.settings || undefined) == undefined) delete this.settings[key];
      });

      try {
        this.sdk.initialization(this.settings);
        this.initialized = true;
        this.launcher_hide();
      } catch (error) {
        console.error('Failed to initialize Intercom:', error);
      }
    }
  },

  launcher_dark_mode: function(enabled) {
    if (enabled) {
      this.sdk.update({ theme_mode: 'dark' });
    } else {
      this.sdk.update({ theme_mode: 'light' });
    }
  },

  launcher_show: function() {
    if (window.intercomSettings) {
      // sdk.update triggers the widget display, but it does not update
      // window.intercomSettings (window.Intercom('getSettings')).
      // This code ensures both the SDK and the global settings reflect
      // the launcher state correctly.
      window.intercomSettings.hide_default_launcher = false;
      this.sdk.update({hide_default_launcher: false});
    }
  },

  launcher_hide: function() {
    if (window.intercomSettings) {
      // sdk.update triggers the widget display, but it does not update
      // window.intercomSettings (window.Intercom('getSettings')).
      // This code ensures both the SDK and the global settings reflect
      // the launcher state correctly.
      window.intercomSettings.hide_default_launcher = true;
      this.sdk.update({hide_default_launcher: true});
    }
  },

  launcher_open: function() {
    this.sdk.show();
  },

  launcher_close: function() {
    this.sdk.hide();
  },

  messages_open: function() {
    this.sdk.showSpace('messages');
  },

  article_open: function(article_id) {
    if (window.intercomSettings?.hide_default_launcher) {
      const id = parseInt(article_id);
      if (!isNaN(id)) {
        window.open('https://intercom.help/comptacrypto/fr/articles/' + id, '_blank', 'noopener,noreferrer');
      }
      return;
    }
    this.sdk.showArticle(article_id);
  },
};
